/* template */
<template minapp="mpx" xlang="wxml"><es-layout :leftArrow="(true)" navbarTitle="订单详情" custom-class="custom-class" :navbarStyle="(navbarStyle)"><div class="order-detail"><div class="header"><div class="header-image"></div>{{ statusName }}</div><div class="train-information-new-card"><div :style='["z-index: 1; position: relative"] | transRpxStyle'><train-information-new :trainInfo="(trainInfo)" @click="showStayInfo(index)" :showDate="(true)"><template slot="footerSlot"><train-order-information-ticket :order="(passengerOrder)" tickets12306 hasSeat/></template></train-information-new></div></div></div><div class="total-fee">总计<span class="total-fee-price">¥</span><span class="total-fee-price-number">{{ personalPay }}</span></div></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mbbf21d72"}'>
  .custom-class
    height 100%
  .order-detail
    padding 2px 10px
    background #FFFFFF
  .header
    background #FFFFFF
    font-size 22px
    color #222222
    font-family PingFang SC
    font-weight 500
    display flex
    align-items center
    margin-bottom 10px
    &-image
      width 74px
      height 74px
      margin-right 10px
      background url('https://dpubstatic.udache.com/static/dpubimg/9unOTi2bqTbd5wWjRej6y.png')
      background-size cover
      background-repeat no-repeat
  .train-information-new-card
    padding 0px 12px 12px
    background #FFFFFF
    margin 0 -12px
  .total-fee
    background-color #ffffff
    padding 17px 12px
    border-radius 8px
    margin 10.5px 10px 0 10px
    color #333333
    font-size 16px
    font-weight 500
    font-family PingFang SC
    &-price
      color #FF6400
      margin-left 6px
    &-price-number
      color #FF6400
      font-size 20px
      font-family Barlow Semi Condensed
      font-weight 400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mbbf21d72"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-detail.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-detail.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mbbf21d72"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'train-order-information-ticket':getComponent(require("../order/components/train-order-information-ticket/index.mpx?isComponent&outputPath=components%2Findex0071e325%2Findex")),'train-information-new':getComponent(require("../../components/train-information-new/index.mpx?isComponent&outputPath=components%2Findex7f4255a4%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
